// extracted by mini-css-extract-plugin
export default {"loading-results":"yvA9SNKensCP9VjZAaAp","loadingResults":"yvA9SNKensCP9VjZAaAp","quote":"CNDc01tmAJjdFhDmzpaH"};